import { VALID_DIGITS as A } from "./ghl-ui.es1223.js";
var g = ";ext=", t = function(a) {
  return "([".concat(A, "]{1,").concat(a, "})");
};
function D(x) {
  var a = "20", o = "15", i = "9", F = "6", n = "[  \\t,]*", e = "[:\\.．]?[  \\t,-]*", r = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", E = "(?:[xｘ#＃~～]|int|ｉｎｔ)", l = "[- ]+", u = "[  \\t]*", v = "(?:,{2}|;)", b = g + t(a), m = n + s + e + t(a) + r, p = n + E + e + t(i) + r, L = l + t(F) + "#", f = u + v + e + t(o) + r, c = u + "(?:,)+" + e + t(i) + r;
  return b + "|" + m + "|" + p + "|" + L + "|" + f + "|" + c;
}
export {
  D as default
};
